export default __webpack_public_path__ + "static/media/referenceChart.ed6000ca.png";